// src/helpers/rutaAjustesCtaCte.js
import axios from "axios";

// SIN slash final
const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL ||
  "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

// arma paths sin doble slash
const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

const debugUrl = (url) => console.log("👉 URL:", API.getUri({ url }));

const buildQuery = (params = {}) => {
  const q = new URLSearchParams();

  if (params.entidadTipo) q.set("entidadTipo", params.entidadTipo);
  if (params.movimiento) q.set("movimiento", params.movimiento);
  if (params.estado) q.set("estado", params.estado);
  if (params.cliente) q.set("cliente", params.cliente);
  if (params.proveedor) q.set("proveedor", params.proveedor);
  if (params.desde) q.set("desde", params.desde);
  if (params.hasta) q.set("hasta", params.hasta);

  const s = q.toString();
  return s ? `?${s}` : "";
};

// ---- AJUSTES CTA CTE ----

export const getAjustesCtaCte = async (params = {}) => {
  const url = p(`ajustesctacte${buildQuery(params)}`);
  debugUrl(url);

  const { data } = await API.get(url, auth());

  return Array.isArray(data?.ajustes)
    ? data.ajustes
    : Array.isArray(data)
    ? data
    : [];
};

export const getAjustesCtaCteRaw = async (params = {}) => {
  const url = p(`ajustesctacte${buildQuery(params)}`);
  debugUrl(url);

  const { data } = await API.get(url, auth());
  return data;
};

export const getAjustesCtaCtePendientes = async (params = {}) => {
  const url = p(`ajustesctacte/pendientes${buildQuery(params)}`);
  debugUrl(url);

  const { data } = await API.get(url, auth());

  return Array.isArray(data?.ajustes)
    ? data.ajustes
    : Array.isArray(data)
    ? data
    : [];
};

export const getAjusteCtaCteById = async (id) => {
  const url = p(`ajustesctacte/${id}`);
  debugUrl(url);

  const { data } = await API.get(url, auth());
  return data;
};

export const postAjusteCtaCte = async (payload) => {
  const url = p("ajustesctacte");
  debugUrl(url);

  const { data } = await API.post(url, payload, auth());
  return data;
};

export const anularAjusteCtaCte = async (id) => {
  const url = p(`ajustesctacte/${id}/anular`);
  debugUrl(url);

  const { data } = await API.put(url, {}, auth());
  return data;
};

export const putAjusteCtaCte = async (id, payload) => {
  const url = p(`ajustesctacte/${id}`);
  debugUrl(url);

  const { data } = await API.put(url, payload, auth());
  return data;
};